import React from 'react';

import IconBtn from '../../../modules/icon-btn/icon-btn';
import currencyFormat from '../../../utils/currencyFormat';
import { getFormatDate } from '../../../utils/utils';

import ReloadIcon from './icons/reload-icon.svg';

import './operation-history-item.scss';

interface OperationHistoryItemProps {
  sum: number;
  date: Date;
  period?: number;
  onRefresh?: (val: number, period?: number) => void;
}

const OperationHistoryItem: React.FC<OperationHistoryItemProps> = ({
  sum,
  date,
  period,
  onRefresh,
}) => (
  <div className="assets-history-module-item">
    <div className="assets-history-module-item__left">
      <div className="assets-history-module-item__sum">
        {currencyFormat(sum)}
      </div>
      {period && (
        <div className="assets-history-module-item__period">{period} дней</div>
      )}
    </div>
    <div className="assets-history-module-item__date">
      {getFormatDate(date)}
    </div>
    <div className="assets-history-module-item__refresh">
      <IconBtn
        outlined
        icon={ReloadIcon}
        onClick={() => onRefresh && onRefresh(sum, period)}
      />
    </div>
  </div>
);

export default OperationHistoryItem;
